export default __webpack_public_path__ + "static/media/ENG. CIVIL.b5be8463.pdf";